import { flow, get, reject } from 'lodash/fp';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CopyStylesModal from './CopyStylesModal';
import clearCopyStylesSelection from '../../actions/copyStyles/clearCopyStylesSelection';
import copyStyles from '../../actions/copyStyles/copyStyles';
import renameWindowLabel from '../../actions/renameWindowLabel';

const mapStateToProps = ({ estimateBuilder }, { designId }) => {
  const { selection } = estimateBuilder.copyStyles;
  const containers = flow(
    get(`entities.estimates.byId.${designId}.containers`),
    reject('isDeleted'),
  )(estimateBuilder);

  return {
    containers,
    selection,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { copyStyles, clearSelection: clearCopyStylesSelection, renameWindowLabel },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CopyStylesModal);
